module.exports = __webpack_public_path__ + "img/web4.d7b49bec.png";